/** A planter, a barrel and a crate on the quay (lantern-water `world.js` `cargo`, the `props` pieces of `layout.js`). */
import * as THREE from 'three';
import type { Prefab } from './types.ts';

export const prefab: Prefab = {
  id: 'cargo',
  buildPrefab(ctx) {
    const root = new THREE.Group();
    ctx.pot(root, 0, -0.35, 0, 0.7);
    ctx.barrel(root, 0.8, -0.25, 0.72);
    ctx.crate(root, 0.5, -0.7, 0.65);
    return { root };
  },
};
